import React from "react";

// UI Components
import { Card, CardBody, Col, Form, FormGroup, Label, Row } from "reactstrap";

const Profile = ({ selected = "profile", user }) =>
  selected === "profile" && (
    <Card>
      <CardBody>
        <Form>
          <Row form>
            <Col lg={6}>
              <FormGroup>
                <Label style={{ fontWeight: "bold" }}>Email</Label>
                <div>{user.email_vch || ""}</div>
              </FormGroup>
            </Col>

            <Col lg={6}>
              <FormGroup>
                <Label style={{ fontWeight: "bold" }}>Permission Level</Label>
                <div>
                  {user.group_id_bint === 1
                    ? "Read Only"
                    : user.group_id_bint === 2
                    ? "Basic"
                    : user.group_id_bint === 3
                    ? "Admin"
                    : user.group_id_bint > 3
                    ? "Super"
                    : "" || ""}
                </div>
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col lg={6}>
              <FormGroup>
                <Label style={{ fontWeight: "bold" }}>First name</Label>
                <div>{user.firstname_vch || ""}</div>
              </FormGroup>
            </Col>

            <Col lg={6}>
              <FormGroup>
                <Label style={{ fontWeight: "bold" }}>Last name</Label>
                <div>{user.lastname_vch || ""}</div>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );

export default Profile;
